t = require('app/scripts/views/internal/teacup-with-helpers')()

module.exports = t.renderable ({ members }) ->
  for { avatarUrl, viewTitle, initials, icon } in members
    t.span '.edit-in-progress', ->
      t.span '.inline-member', ->
        title = viewTitle
        if avatarUrl
          t.img '.inline-member-av', { src: [avatarUrl, '30.png'].join('/'), alt: title, title }
        else
          t.span '.initials', { title }, ->
            t.text initials
      if icon
        t.icon icon, class: 'icon'
